import { Setting } from '../../../../common/types/settings';
import type { Form } from '../../../../common/types/form';
import type { FhfChildMeasure } from '../../../../common/types/child';

const measureForm = (advisors: Setting[]): Form<FhfChildMeasure> => {
  const advisorOptions = advisors.map((advisor) => advisor.value);

  return {
    key: 'measure',
    title: 'Notiz',
    fields: [
      {
        key: 'advisor',
        label: 'Mitarbeiterin',
        fieldTypes: 'autocomplete',
        options: advisorOptions,
      },
      {
        key: 'date',
        label: 'Datum',
        fieldTypes: 'date',
      },
      {
        key: 'contactType',
        label: 'Kontaktart',
        fieldTypes: 'select',
        options: [],
      },
      {
        key: 'subject',
        label: 'Thema',
        fieldTypes: 'text',
        xsWidth: 12,
      },
      {
        key: 'notice',
        label: 'Notiz',
        fieldTypes: 'richTextArea',
        rows: 15,
        xsWidth: 12,
      },
    ],
  };
};

export default measureForm;
